export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const USER_DATA_REQUEST = 'USER_DATA_REQUEST';
export const USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
export const USER_DATA_ERROR = 'USER_DATA_ERROR';

export const SET_EVENT_CONTACTS = 'SET_EVENT_CONTACTS';

export const FETCH_USER_CONTACTS_REQUEST = 'FETCH_USER_CONTACTS_REQUEST';
export const FETCH_USER_CONTACTS_SUCCESS = 'FETCH_USER_CONTACTS_SUCCESS';
export const FETCH_USER_CONTACTS_ERROR = 'FETCH_USER_CONTACTS_ERROR';

export const ADD_EVENT_SELECTED_CONTACTS_REQUEST = 'ADD_EVENT_SELECTED_CONTACTS_REQUEST';
export const ADD_EVENT_SELECTED_CONTACTS_SUCCESS = 'ADD_EVENT_SELECTED_CONTACTS_SUCCESS';
export const ADD_EVENT_SELECTED_CONTACTS_ERROR = 'ADD_EVENT_SELECTED_CONTACTS_ERROR';
export const SET_EVENT_SELECTED_CONTACTS = 'SET_EVENT_SELECTED_CONTACTS';

export const ADD_USER_SELECTED_CONTACTS = 'ADD_USER_SELECTED_CONTACTS';
export const SET_USER_SELECTED_CONTACTS = 'SET_USER_SELECTED_CONTACTS';
export const DELETE_USER_SELECTED_CONTACTS = 'DELETE_USER_SELECTED_CONTACTS';

export const SET_FINAL_USER_SELECTED_CONTACTS = 'SET_FINAL_USER_SELECTED_CONTACTS';
export const DELETE_FINAL_USER_SELECTED_CONTACTS = 'DELETE_FINAL_USER_SELECTED_CONTACTS';

export const SET_FINAL_EVENT_SELECTED_CONTACTS = 'SET_FINAL_EVENT_SELECTED_CONTACTS';
export const DELETE_FINAL_EVENT_SELECTED_CONTACTS = 'DELETE_FINAL_EVENT_SELECTED_CONTACTS';

export const DELETE_EVENT_SELECTED_CONTACTS_REQUEST = 'DELETE_EVENT_SELECTED_CONTACTS_REQUEST';
export const DELETE_EVENT_SELECTED_CONTACTS_SUCCESS = 'DELETE_EVENT_SELECTED_CONTACTS_SUCCESS';
export const DELETE_EVENT_SELECTED_CONTACTS_ERROR = 'DELETE_EVENT_SELECTED_CONTACTS_ERROR';

export const SEARCH_CONTACT_REQUEST = 'SEARCH_CONTACT_REQUEST';
export const SEARCH_CONTACT_SUCCESS = 'SEARCH_CONTACT_SUCCESS';
export const SEARCH_CONTACT_UNREGISTERED = 'SEARCH_CONTACT_UNREGISTERED';
export const SEARCH_CONTACT_ERROR = 'SEARCH_CONTACT_ERROR';
export const CLEAR_SEARCH_CONTACT = 'CLEAR_SEARCH_CONTACT';

export const ADD_USER_CONTACT_REQUEST = 'ADD_USER_CONTACT_REQUEST';
export const ADD_USER_CONTACT_SUCCESS = 'ADD_USER_CONTACT_SUCCESS';
export const ADD_USER_CONTACT_ERROR = 'ADD_USER_CONTACT_ERROR';

export const CREATE_USER_CONTACT_REQUEST = 'CREATE_USER_CONTACT_REQUEST';
export const CREATE_USER_CONTACT_SUCCESS = 'CREATE_USER_CONTACT_SUCCESS';
export const CREATE_USER_CONTACT_ERROR = 'CREATE_USER_CONTACT_ERROR';

export const DELETE_USER_CONTACT_REQUEST = 'DELETE_USER_CONTACT_REQUEST';
export const DELETE_USER_CONTACT_SUCCESS = 'DELETE_USER_CONTACT_SUCCESS';
export const DELETE_USER_CONTACT_ERROR = 'DELETE_USER_CONTACT_ERROR';

export const RESET_USER_DATA = 'RESET_USER_DATA';

export const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR';
